import React from 'react';
import { Tabs, Tab } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import UserForm from './Form';
import SubscriptionsTab from './SubscriptionsTab'; // Import the new SubscriptionsTab component
import ChangePasswordForm from './ChangePasswordForm';

const User: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const isEdit = Boolean(id);

  return (
    <>
      {isEdit ? (
        <Tabs defaultActiveKey="basicInfo" id="user-form-tabs">
          <Tab eventKey="basicInfo" title="Basic Info">
            <UserForm />
          </Tab>
       
          <Tab eventKey="subscriptions" title="Subscriptions">
            <SubscriptionsTab userId={+id!} /> {/* Pass the userId to the SubscriptionsTab */}
          </Tab>
          <Tab eventKey="changePassword" title="Change Password">
            <ChangePasswordForm userId={+id!} />
          </Tab>
        </Tabs>
      ) : (
        <UserForm />
      )}
    </>
  );
};

export default User;